import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
import { Id } from '@sigma/common/schema/Id.js';
export const FileUploadEndpointParams = z.object({
    /** Chat ID the file is attached to */
    chatId: Id,
    /** Original file name */
    name: z.string().check(z.minLength(1)).check(z.maxLength(255)),
    /** MIME content type */
    contentType: z.string(),
    /** File size in bytes */
    size: z.int32(),
    /** Image width in pixels (only for image files) */
    width: z.optional(z.number()),
    /** Image height in pixels (only for image files) */
    height: z.optional(z.number()),
});
/**
 * Endpoint for generating a presigned URL for patient file uploads.
 * Creates a file record in pending state and returns an upload URL.
 */
export const FileUploadEndpoint = defineEndpoint({
    name: 'FileUpload',
    input: FileUploadEndpointParams,
    output: defineEndpoint.output(),
});
//# sourceMappingURL=FileUploadEndpoint.js.map